export default __webpack_public_path__ + "static/media/kitap5.e13dc041.jpg";